import { useMemo, useState } from "react";
import FancyHeader from "./components/header/FancyHeaderİs";
import Sidebar from "./components/sidebar/Sidebar";
import PlanCard from "./components/plans/PlanCard";
import PlanDetail from "./components/plans/PlanDetail";
import DataLoader from "./components/results/DataLoader";
import IconLogo from "./components/ui/IconLogo";
import { demoData } from "./data/demoData";
import { clone } from "./utils/format";
import Router from "./router/Router";
import { AuthContextProvider } from "./Context/AuthContext";
import { BrowserRouter } from "react-router-dom";
import { BrowserRouter as RouterApp } from "react-router-dom";


export default function App() {
  const [userData, setUserData] = useState({
    token: undefined,
    user: undefined,
  });

  // Kaydedilebilir demo verisi


  const [data, setData] = useState(demoData);

  // UI state
  const [selectedBrandId, setSelectedBrandId] = useState(null);
  const [openedPlanId, setOpenedPlanId] = useState(null);
  const [brandSearch, setBrandSearch] = useState("");
  const [creating, setCreating] = useState(false);

  // Yüklenen Excel veri setleri (BUFF100/250/500 vs.)
  const [datasets, setDatasets] = useState([]); // [{ name, rows }]

  // Arama için marka index’i
  const brandIndex = useMemo(() => {
    const arr = [];
    data.advertisers.forEach((adv) => {
      adv.brands.forEach((b) => {
        arr.push({
          id: b.id,
          name: b.name,
          advertiser: adv.name,
          campaigns: b.plans.map((p) => p.meta.campaign).join(" "),
        });
      });
    });
    return arr;
  }, [data]);

  const brandSuggestions = useMemo(() => {
    const q = brandSearch.trim().toLowerCase();
    if (!q) return [];
    return brandIndex
      .filter(
        (it) =>
          it.name.toLowerCase().includes(q) ||
          it.advertiser.toLowerCase().includes(q) ||
          it.campaigns.toLowerCase().includes(q)
      )
      .slice(0, 6);
  }, [brandSearch, brandIndex]);

  // Seçili marka
  const brand = useMemo(() => {
    for (const adv of data.advertisers) {
      for (const b of adv.brands) if (b.id === selectedBrandId) return b;
    }
    return null;
  }, [selectedBrandId, data]);

  // Açık plan
  const openedPlan = useMemo(() => {
    if (!brand || !openedPlanId) return null;
    return brand.plans.find((p) => p.id === openedPlanId) || null;
  }, [brand, openedPlanId]);

  // Yeni plan kaydetme
  const handleCreateSave = ({ brandId, plan }) => {
    setData((prev) => {
      const next = clone(prev);
      for (const adv of next.advertisers) {
        const b = adv.brands.find((x) => x.id === brandId);
        if (b) {
          // id çakışması önleme
          let finalId = plan.id;
          const existingIds = new Set(b.plans.map((p) => p.id));
          let i = 2;
          while (existingIds.has(finalId)) finalId = `${plan.id}-${i++}`;
          b.plans.unshift({ ...plan, id: finalId });
          setSelectedBrandId(brandId);
          setOpenedPlanId(finalId);
          break;
        }
      }
      return next;
    });
    setCreating(false);
  };

  return (
    <div className="min-h-screen">
      <RouterApp>
        <AuthContextProvider value={{ userData, setUserData }}>
          <FancyHeader
            brand={brand}
            plan={openedPlan}
            searchValue={brandSearch}
            onSearch={setBrandSearch}
            suggestions={brandSuggestions}
            onPickSuggestion={(id) => {
              setSelectedBrandId(id);
              setOpenedPlanId(null);
              setBrandSearch("");
              setCreating(false);
            }}
            onNewPlan={() => setCreating(true)}
          />
          <Router />
        </AuthContextProvider>
      </RouterApp>
    </div>
  );
}
